import React from 'react';

const CardDiners = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
    >
      <g clipPath="url(#clip0_19672_16139)">
        <path
          d="M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z"
          fill="#CCECFF"
        />
        <path
          d="M19.5584 8.05217C19.5584 4.47286 16.5709 1.99892 13.2974 2H10.4805C7.16808 1.99881 4.44165 4.47361 4.44165 8.05217C4.44165 11.326 7.16815 14.0158 10.4805 13.9999H13.2974C16.5706 14.0157 19.5584 11.3251 19.5584 8.05217Z"
          fill="#0079BE"
        />
        <path
          d="M10.4983 2.50696C7.47149 2.50789 5.0189 4.96628 5.01782 8.00036C5.01858 11.0339 7.47127 13.492 10.4983 13.493C13.5257 13.4921 15.9791 11.034 15.9794 8.00036C15.979 4.96621 13.5258 2.50804 10.4983 2.50696Z"
          fill="white"
        />
        <path
          d="M7.03418 7.98551C7.03706 6.50289 7.96116 5.2386 9.26423 4.73621V11.2341C7.96116 10.732 7.03702 9.46835 7.03418 7.98555V7.98551ZM11.7506 11.2357V4.73639C13.0542 5.23759 13.9798 6.5026 13.9821 7.98591C13.9797 9.46968 13.0542 10.7338 11.7506 11.2359V11.2357Z"
          fill="#0079BE"
        />
      </g>
      <defs>
        <clipPath id="clip0_19672_16139">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CardDiners;
